module.exports = __webpack_public_path__ + "img/icon-medal@2x.73d6394c.png";